import Image from "next/image"

import { CF_S3_URL } from "@/lib/cloudflare-loader"
import { Link } from "../ui/link"

interface Logo {
  name: string
  logo: string
  width: number
  height: number
  href: string
  type: "hotel" | "destination"
  className?: string
}

const LOGOS: Logo[] = [
  {
    name: "Visit the USA",
    logo: `${CF_S3_URL}/web/logo-brand-usa-ko.svg`,
    width: 95,
    height: 48,
    href: "https://americathebeautiful.com",
    type: "destination",
  },
  {
    name: "esencial Costa Rica",
    logo: `${CF_S3_URL}/web/costarica_logo-ko.svg`,
    width: 130,
    height: 59,
    href: "https://www.visitcostarica.com",
    type: "destination",
  },
  {
    name: "Visit California",
    logo: `${CF_S3_URL}/web/visit-california-logo-ko.svg`,
    width: 160,
    height: 50,
    href: "https://www.visitcalifornia.com/road-trips",
    type: "destination",
  },
  {
    name: "esencial Costa Rica",
    logo: `${CF_S3_URL}/web/logo-discover-puerto-rico-ko.svg`,
    width: 152,
    height: 47,
    href: "https://www.discoverpuertorico.com",
    type: "destination",
  },
  {
    name: "Monterey County",
    logo: `${CF_S3_URL}/web/biz-logo-5-ko.png`,
    width: 140,
    height: 40,
    href: "https://www.seemonterey.com",
    type: "destination",
  },
  {
    name: "The Outer Banks of North Carolina",
    logo: `${CF_S3_URL}/web/logo-outer-banks-ko.svg`,
    width: 186,
    height: 37,
    href: "https://www.outerbanks.org",
    type: "destination",
  },
  {
    name: "Visit Truckee Tahoe",
    logo: `${CF_S3_URL}/web/logo-truckee-tahoe-ko.svg`,
    width: 125,
    height: 55,
    href: "https://www.visittruckeetahoe.com",
    type: "destination",
  },
  {
    name: "Travel Nevada",
    logo: `${CF_S3_URL}/web/logo-travel-nevada.svg`,
    width: 100,
    height: 81,
    href: "https://travelnevada.com",
    type: "destination",
    className: "invert",
  },
  {
    name: "Visit New Orleans",
    logo: `${CF_S3_URL}/web/logo-new-orleans.svg`,
    width: 180,
    height: 30,
    href: "https://www.neworleans.com",
    type: "destination",
    className: "invert",
  },
  {
    name: "Norway by Locals",
    logo: `${CF_S3_URL}/web/logo-norway-by-locals-ko.svg`,
    width: 180,
    height: 35,
    href: "https://norwaybylocals.no",
    type: "destination",
  },
  {
    name: "The Landsby",
    logo: `${CF_S3_URL}/web/logo-the-landsby-ko.png`,
    width: 180,
    height: 47,
    href: "https://www.thelandsby.com",
    type: "hotel",
  },
  {
    name: "Casia Inn",
    logo: `${CF_S3_URL}/web/logo-casia-inn-ko.png`,
    width: 180,
    height: 33,
    href: "https://casiainnsonoma.com/",
    type: "hotel",
  },
  {
    name: "Hotel Wailea",
    logo: `${CF_S3_URL}/web/logo-hotel-wailea-ko.svg`,
    width: 152,
    height: 63,
    href: "https://hotelwailea.com",
    type: "hotel",
  },
]

export function BusinessPartnerLogos({
  type,
}: {
  type: "hotel" | "destination"
}) {
  const logosToShow = type ? LOGOS.filter((logo) => logo.type === type) : LOGOS

  return (
    <div className="mx-auto flex flex-wrap items-center justify-center gap-12 *:flex *:w-32 *:items-center *:justify-center sm:max-w-6xl sm:gap-20 sm:px-0 sm:*:w-auto">
      {logosToShow.map((logo) => (
        <Link
          key={logo.name}
          href={logo.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src={logo.logo}
            alt={logo.name}
            width={logo.width}
            height={logo.height}
            unoptimized
            className={logo.className}
          />
        </Link>
      ))}
    </div>
  )
}
